export default "__VITE_ASSET__DPWchMyY__"